<app-search-input #appSearch
                  [label]="label"
                  [autofocus]="autofocus"
                  [placeholder]="placeholder"
                  [formControl]="barcodeControl"
                  [isDrugOption]="!wholesalerSearch"
                  [hideDropdown]="hideDropdown"
                  [searchResults]="searchResults || innerSearchList"
                  [loading]="loading || (searchLoading$ | async)"
                  [showLocation]="showLocation && !wholesalerSearch"
                  [color]="color"
                  (searchValueChanged)="handleSearchInput($event)"
                  (searchCleared)="searchClear()"
                  (optionSelected)="optionSelect($event)"
                  (keydownTab)="keydownTab.emit()"
                  [errorMessage]="errorMessage"
                  [processed]="processed"
                  [hasError]="hasError"
                  [displayError]="displayError && barcodeControl?.value"
></app-search-input>
